<template>
  <div class="dft-container">

    <!-- 头部部分 -->
    <div ref="search_d" class="dft-search">
<!--      <el-tabs v-model="activeName" @tab-click="handleClick" class="search_tab">-->
<!--        <el-tab-pane label="快递订单售后" name="1"></el-tab-pane>-->
<!--        <el-tab-pane label="平台介入售后" name="2"></el-tab-pane>-->
<!--      </el-tabs>-->
      <el-form label-width="120px" label-height="60px" class="search_form">
        <el-row>
<!--          <el-col :span="6">-->
<!--            <el-form-item label="订单状态" prop="orderStatus">-->
<!--              <el-select clearable v-model="queryInfo.condition.orderStatus" placeholder="请选择" style="width: 100%;">-->
<!--                <el-option   v-for="(item,index) in orderStatusList" :key="index" :label="item.label"-->
<!--                           :value="item.value"></el-option>-->
<!--              </el-select>-->
<!--            </el-form-item>-->
<!--          </el-col>-->
          <el-col :span="6">
            <el-form-item label="客户昵称" prop="memberName">
              <el-input v-model="queryInfo.condition.memberName" @keyup.enter.native="search" placeholder="请输入"
                        clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="收货人姓名" prop="recipientName">
              <el-input v-model="queryInfo.condition.recipientName" @keyup.enter.native="search" placeholder="请输入"
                        clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="联系电话" prop="recipientPhone">
              <el-input v-model="queryInfo.condition.recipientPhone" @keyup.enter.native="search" placeholder="请输入"
                        clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="订单号" prop="orderNumber">
              <el-input v-model="queryInfo.condition.orderNumber" @keyup.enter.native="search" placeholder="请输入"
                        clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="申请退款时间" prop="routeName">
              <!--              <el-date-picker v-model="queryInfo.condition.orderTime" value-format="yyyy-MM-dd" type="date" style="width: 100%;"-->
              <!--               clearable placeholder="请选择时间">-->
              <!--              </el-date-picker>-->
              <!-- <el-date-picker v-model="daterange" value-format="yyyy-MM-dd" type="daterange" style="width: 100%;"
                @change="handleDateChange" range-separator="-" unlink-panels clearable start-placeholder="开始时间"
                end-placeholder="结束时间">
              </el-date-picker> -->

              <el-date-picker
                @change="change"
                v-model="valuechange"
                style="width: 100%"
                type="daterange"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
                :default-time="['00:00:00', '23:59:59']"
              />

            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label-width="30px">
              <el-button type="primary" @click="search" icon="el-icon-search">查询</el-button>
              <el-button @click="reset" icon="el-icon-refresh-left">重置</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <!-- 表格部分 -->
    <div class="dft-table">
      <!-- <el-button type="primary" @click="newBtn" class="mt10">添加路线</el-button> -->
      <!-- <div class="mt10 table_btn">
        <el-popconfirm title="确定删除吗？" @onConfirm="batchDelete()" @confirm="batchDelete()">
          <el-button type="danger" slot="reference" style="margin-left: 10px">批量删除</el-button>
        </el-popconfirm>
        <div>
          <el-button v-if="activeName == '1'" type="primary" @click="toExport" class="mt10">导出装车单</el-button>
          <el-button v-else-if="activeName == '2'" type="primary" @click="toExport" class="mt10">导出配送单</el-button>
          <el-button v-else-if="activeName == '3'" type="primary" @click="toExport" class="mt10">导出签收单</el-button>
        </div>
      </div> -->
      <el-tabs v-model="activeName2" @tab-click="handleClick2" class="search_tab">
        <el-tab-pane label="全部" name="-1"></el-tab-pane>
        <el-tab-pane label="待退款" name="0"></el-tab-pane>
        <el-tab-pane label="已退款" name="1"></el-tab-pane>
        <el-tab-pane label="已拒绝" name="2"></el-tab-pane>
        <el-tab-pane label="已取消" name="3"></el-tab-pane>
      </el-tabs>
      <el-table border ref="table" :key="refreshTable"  v-loading="loading" :data="tableData" tooltip-effect="dark" style="width: 100%"
                :height="height">
        <!-- <el-table-column type="selection" width="55"></el-table-column> -->
        <el-table-column label="序号" type="index" width="50" align="center"></el-table-column>

        <el-table-column label="客户昵称" align="center" show-overflow-tooltip>
          <template slot-scope="scope">{{ scope.row.memberName }}</template>
        </el-table-column>
        <el-table-column label="收货人姓名" align="center" width="120px" show-overflow-tooltip>
          <template slot-scope="scope">{{ scope.row.recipientName }}</template>
        </el-table-column>
        <el-table-column label="联系电话" align="center" width="120px" show-overflow-tooltip>
          <template slot-scope="scope">{{ scope.row.recipientPhone }}</template>
        </el-table-column>
        <el-table-column label="订单编号" width="200px" align="center" show-overflow-tooltip>
          <template slot-scope="scope">{{ scope.row.orderNumber }}</template>
        </el-table-column>
        <el-table-column label="订单明细" align="center" width="120" show-overflow-tooltip>
          <template slot-scope="scope">
            <div style="display: flex; justify-content: center">
              <el-image v-for="(img, index) in scope.row.imgList.slice(0, 3)" v-bind:key="index"
                        :src="img" style="margin: 0 3px;width: 50px;height: 50px;"></el-image>
              <div v-if="scope.row.imgList.length > 3" style="display: flex;align-items: flex-end;color: red;">
                +{{ scope.row.imgList.length - 3 }}
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="订单金额" align="center" prop="orderAmount" show-overflow-tooltip>
          <template slot-scope="scope">{{ scope.row.orderAmount }}</template>
        </el-table-column>
        <el-table-column label="订单交易时间" align="center" width="150" show-overflow-tooltip>
          <template slot-scope="scope">{{ scope.row.orderTime }}</template>
        </el-table-column>
        <el-table-column v-if="activeName == '1'" label="订单状态" width="130" align="center" show-overflow-tooltip>
          <template slot-scope="scope">{{ scope.row.orderStatus | getstatus }}</template>
        </el-table-column>
        <el-table-column label="申请退款时间" align="center" width="150" show-overflow-tooltip>
          <template slot-scope="scope">{{ scope.row.refundApplicationTime }}</template>
        </el-table-column>
        <!-- <el-table-column v-if="activeName == '1'" label="申请退款金额" align="center" prop="orderAmount" show-overflow-tooltip>
          <template slot-scope="scope">{{ scope.row.orderAmount }}</template>
        </el-table-column> -->
        <el-table-column label="退款状态" align="center" show-overflow-tooltip>
          <template slot-scope="scope">{{ scope.row.refundReviewStatus | getrestatus }}</template>
        </el-table-column>
        <el-table-column label="退款金额" align="center" show-overflow-tooltip>
          <template slot-scope="scope">{{ scope.row.refundAmount }}</template>
        </el-table-column>
        <el-table-column v-if="activeName == '2'" label="是否平台介入" align="center" show-overflow-tooltip>
          <template slot-scope="scope">{{ scope.row.plant | yorn }}</template>
        </el-table-column>
        <!-- <el-table-column label="申请平台介入时间" align="center" show-overflow-tooltip>
          <template slot-scope="scope">{{ scope.row.deliveryTime }}</template>
        </el-table-column> -->
        <el-table-column label="操作" fixed="right"  width="155" align="center">
          <template slot-scope="scope">
            <!-- <el-button type="text" @click="edit(scope.row, true)" size="small">查看详情</el-button> -->
            <el-button style="color: #f44;"  :disabled="scope.row.refundAmount == scope.row.actualAmount  " type="text" @click="handleforceback(scope.row)"
                       size="small">退款
            </el-button>
<!--            <el-button style="color: #f44;" v-if="activeName == '2'" type="text" @click="handleforceback(scope.row)"-->
<!--                       size="small">强制退款-->
<!--            </el-button>-->
            <!-- <el-popconfirm title="确定删除吗？" @onConfirm="handleDelte(scope.row.id)">
              <el-button slot="reference" type="text">删除</el-button>
            </el-popconfirm> -->
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <div class="block">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                       :current-page="queryInfo.currPage" :page-sizes="[100, 200, 300, 400]"
                       :page-size="queryInfo.pageSize"
                       layout="total, sizes, prev, pager, next, jumper" :total="total">
        </el-pagination>
      </div>
    </div>

    <el-dialog :title="returntitle" :visible.sync="showDialog" width="960px" top="8vh" class="dft-dialog">
      <el-form ref="form" :model="refundData" :rules="rules" label-width="100px">
        <el-row :gutter="10">
          <el-col :span="24" class="dialog_sub_title" style="margin-bottom: 16px;">
            <div class="">退款信息</div>
          </el-col>
          <el-col :span="24">
            <el-form-item label="用户退款说明" prop="refundReason">
              {{refundData.refundReason}}
<!--              <el-input v-model="refundData.refundReason" type="area" placeholder="请输入名称" readonly></el-input>-->
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="用户退款凭证" prop="refundReviewerImgs">
              <div v-for="(img, index) in refundData.refundReviewerImgs" v-bind:key="index">
                <el-image v-if="img" :src="img" style="margin: 0 3px;width: 50px;height: 50px;"></el-image>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="24" class="dialog_sub_title" style="margin-bottom: 16px;">
            <div class="">订单信息</div>
          </el-col>
          <!-- orderItems refundReviewerImgs-->
          <el-col :span="24" v-for="(item,index) in refundData.orderItemRefundList" :key="index">
            <el-row :gutter="10" v-if="item">
              <el-col :span="24" class="flex" style="padding: 10px 20px;">
                <el-image :src="item.listImg" style="margin: 0 3px;width: 80px;height: 80px;"></el-image>
                <div class="flex justify-between flex1" style="padding-left: 18px;">
                  <div class="flex1">
                    <div style="font-weight: 600;">{{ item.productName }}</div>
                    <div class="">{{ item.skuName }} 共{{ item.count }}件</div>
                    <el-checkbox v-model="item.refundReviewStatus" :true-label="2" :false-label="1">不退款</el-checkbox>
                  </div>
                </div>
                <div class="">实付<span style="color: red;">￥{{ item.actualAmount || 0 }}</span></div>
              </el-col>
              <el-col :span="24" class="flex">
                <el-form-item label="退款金额"  >
                  <el-input  type="number" v-model="item.refundAmount" placeholder="请输入">
                    <div slot="suffix" class="flex align-center" style="height: 100%;">元</div>
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="退款说明" prop="refundReviewerRemark">
                  <el-input v-model="item.refundReviewerRemark" type="area" placeholder="请输入名称"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="退款凭证" prop="refundReviewerImgs">
                  <el-upload
                    class="avatar-uploader"
                    list-type="picture-card"
                    :action="$uploadURL" v-if="item&&item.refundReviewerImgs"
                    :show-file-list="true" :fileList="item.refundReviewerImgs"
                    :on-success="(res, file)=>handleImgSuccess(res, file, 'refundReviewerImgs',index)"
                  >
                    <i slot="default" v-show="!false" class="el-icon-plus"></i>
                    <div slot="file" slot-scope="{file}">
                      <img
                        class="el-upload-list__item-thumbnail"
                        :src="file.url" alt=""
                      >
                      <span class="el-upload-list__item-actions">
                        <span
                          class="el-upload-list__item-preview"
                          @click="handlePictureCardPreview(file)"
                        >
                          <i class="el-icon-zoom-in"></i>
                        </span>
                        <span
                          v-if="!false"
                          class="el-upload-list__item-delete"
                          @click="handleRemove(file,true,index)"
                        >
                          <i class="el-icon-delete"></i>
                        </span>
                      </span>
                    </div>
                  </el-upload>
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer">
        <el-button size="small" @click="showDialog = false">返回</el-button>
        <el-button size="small" type="primary" @click="forceback">确定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="预览" :visible.sync="dialogVisible" top="10vh" height="70vh">
      <img width="100%" :src="dialogImageUrl" alt="" style="height: 100%;object-fit: contain;">
    </el-dialog>
  </div>
</template>

<script>
export default {
  data () {
    return {
      labelType: 'add',
      rules: {},
      activeName: '1',
      activeName2: '-1',
      total: 0,
      queryInfo: {
        pageSize: 100,
        currPage: 1,
        condition: {
          refundReviewStatus: null,
          orderType: null,
          // plant: 0,
          refundStatus: null,
          // supplierCode: '00000000',
          saleAfterStatus: 1,
          orderTime: ''
        }
      },
      form: {
        siteList: [],
        siteNameList: [],
        siteCodeList: [],
        remarkList: []
      },
      showDialog: false,
      tableData: [],
      height: window.innerHeight - 220, // 表格高度
      headerHeight: 0,
      // notonlysite: true,
      selectedRows: [],
      // 选站
      SqueryInfo: {
        pageSize: 100,
        currPage: 1,
        condition: {}
      },
      Stotal: 0,
      taskTeamData: {},
      StableData: [],
      daterange: [],
      valuechange: [],
      orderStatusList: [
        { label: '待司机装车', value: 1 },
        { label: '待司机配送', value: 2 },
        { label: '司机配送中', value: 3 },
        { label: '司机已送达', value: 4 },
        { label: '待用户核销', value: 5 },
        { label: '待团长配送', value: 6 },
        { label: '已完成', value: 7 },
        { label: '已评价', value: 8 }
      ],
      returntitle: '退款',
      refreshTable: null,
      backform: {},
      backformDialog: false,
      dialogImageUrl: '',
      dialogVisible: false,
      refundData: {},
      loading: false
    }
  },
  filters: {
    getstatus (status) {
      switch (status) {
        case 1:
          return '待司机装车'
        case 2:
          return '待司机配送'
        case 3:
          return '司机配送中'
        case 4:
          return '司机已送达'
        case 5:
          return '待用户核销'
        case 6:
          return '待团长配送'
        case 7:
          return '已完成'
        case 8:
          return '已评价'

        default:
          return ''
      }
    },
    yorn (val) {
      switch (val) {
        case 0:
          return '否'
        case 1:
          return '是'

        default:
          return ''
      }
    },
    getsiteType (siteType) {
      switch (siteType) {
        case 1:
          return '站点配送'
        case 2:
          return '企业配送'

        default:
          return ''
      }
    },
    // 退款审核状态
    getrestatus (siteType) {
      switch (siteType) {
        case 0:
          return '待退款'
        case 1:
          return '已退款'
        case 2:
          return '已拒绝'
        case 3:
          return '已取消'

        default:
          return ''
      }
    }
  },
  created () {
    this.search()
  },

  mounted () {
    this.$nextTick(() => {
      // 获取定义ref属性 和 元素高度
      this.headerHeight = this.$refs.search_d.offsetHeight
      window.addEventListener('resize', this.getHeight())
    })
  },

  methods: {
    // 监听表格高度
    change () {
      console.log(this.valuechange)
      if (this.valuechange) {
        this.queryInfo.condition.applyStartTime = this.valuechange[0]
        this.queryInfo.condition.applyEndTime = this.valuechange[1]
      } else {
        this.valuechange = []
        this.queryInfo.condition.applyStartTime = ''
        this.queryInfo.condition.applyEndTime = ''
      }
    },

    onBlur(val){
      const reg = /^\d+(\.\d{1,2})?$/;
      if (!reg.test(val)) {
        this.$message.error("退款金额必须为非负数且最多保留两位小数")
      }
    },

    getHeight () {
      this.height = window.innerHeight - this.headerHeight - 220
    },
    handleClick (tab) {
      console.log(tab, '|', this.activeName)
      switch (tab.name) {
        case '1':
          this.queryInfo.condition.plant = 0
          break
        case '2':
          this.queryInfo.condition.plant = 1
          break
          // case '3':
          //   this.queryInfo.condition.statusList = [4]
          //   break;

        default:
          break
      }
      // this.queryInfo.condition.siteType = 0
      this.activeName2 = '-1'
      this.search()
    },
    handleClick2 (tab) {
      console.log(tab, '|', this.activeName2)
      switch (tab.name) {
        case '-1':
          this.queryInfo.condition.refundReviewStatus = null
          break
        case '0':
          this.queryInfo.condition.refundReviewStatus = 0
          break
        case '1':
          this.queryInfo.condition.refundReviewStatus = 1
          break
        case '2':
          this.queryInfo.condition.refundReviewStatus = 2
          break
        case '3':
          this.queryInfo.condition.refundReviewStatus = 3
          break

        default:
          break
      }
      this.search()
    },
    handleDateChange (val) {
      this.queryInfo.condition.startTime = val[0]
      this.queryInfo.condition.endTime = val[1]
    },
    // 获取数据
    getList () {
      var that = this
      that.loading = true
      const _queryInfo = {
        ...this.queryInfo
      }
      // _queryInfo.condition
      that.$http.post('/order/list', _queryInfo).then(function (response) {
        console.log(response.data.data)
        if (response.data.code == 200) {
          that.loading = false
          that.total = response.data.data.count
          that.queryInfo.currPage = response.data.data.currPage
          that.tableData = response.data.data.data
          that.refreshTable = Math.random()
        }
      })
    },
    getrefundList (refundOrderCode) {
      var that = this
      const _queryInfo = {
        refundOrderCode: refundOrderCode
      }
      that.refundData = {}
      that.$http.post('/refundOrder/queryDetail', _queryInfo).then(response => {
        if (response.data.code == 200) {
          that.refundData = {
            ...response.data.data,
            refundReviewerImgs: response.data.data.refundReviewerImgs.split(','),
            orderItemRefundList: response.data.data.orderItemRefundList.map(ii => {
              return {
                ...ii,
                refundReviewerImgs: ii.refundReviewerImgs.split(',').filter(ii => ii != '')?.map(item => {
                  return {
                    name: item,
                    url: item
                  }
                }) || []
              }
            })
          }
          this.showDialog = true
        }
        console.log(response.data.data, that.refundData)
      })
    },
    async handleImgSuccess (res, file, attr, index) {
      console.log(res, file, file.response.data.url, '88888888', this.refundData)
      console.log('445555', this.refundData)
      const _url = file.response.data.url
      this.refundData.orderItemRefundList?.[index].refundReviewerImgs.push({
        name: _url,
        url: _url
      })
    },
    handleRemove (file, boolean, ii) {
      console.log(file, boolean)
      const index = this.refundData.orderItemRefundList?.[ii].refundReviewerImgs.findIndex(item => {
        return item.url == file.url
      })
      this.refundData.orderItemRefundList?.[ii]?.refundReviewerImgs?.splice(index, 1)
    },
    handlePictureCardPreview (file, iscustom) {
      if (iscustom) {
        this.dialogImageUrl = file
      } else {
        this.dialogImageUrl = file.url
      }

      this.dialogVisible = true
    },
    // 保存
    handleSave () {
      var that = this
      that.$http.post('/taskTeam/save', that.form).then(function (response) {
        if (response.data.code == 200) {
          that.$notify.success({
            title: '提示',
            message: '保存成功',
            showClose: true
          })
          that.showDialog = false
          that.search()
        } else {
          that.$notify.info({
            title: '提示',
            message: response.data.message,
            showClose: true
          })
        }
      }).catch(function (error) {

      })
    },
    handleforceback (row) {
      this.returntitle = this.activeName == '1' ? '退款' : '强制退款'
      console.log('???', row, row.refundOrderCode)
      if (!row.refundOrderCode) {
        return this.$message.warning('无可退款商品！')
      }
      this.getrefundList(row.refundOrderCode)
    },
    async forceback () {
      console.log(';;///', this.refundData)
      if (!(this.refundData.orderItemRefundList.length > 0)) {
        return this.$message.warning('无可退款商品！')
      }
      const _userInfo = JSON.parse(localStorage.getItem('userInfo'))
      const _data = {
        orderNumber: this.refundData.orderNumber,
        orderItemRefundList: this.refundData.orderItemRefundList.map(item => {
          console.log('it--em', item, item.refundReviewerImgs)
          return {
            ...item,
            refundReviewerImgs: item.refundReviewerImgs.map(imgg => imgg.url).join(',')
          }
        }),
        refundReviewerCode: _userInfo?.userInfo?.userCode, // uni.getStorageSync("supplierInfo").userInfo.supplierCode,
        refundReviewerName: _userInfo?.userInfo?.loginName// uni.getStorageSync("supplierInfo").userInfo.name,
        // plantStatus: 1,
      }
      // console.log('...',_data)
      // return
      const _data2 = {
        ...this.refundData,
        ..._data,
        plantStatus: 1
      }
      delete _data2.refundReviewStatus
      const confirmResult = await this.$confirm('确定退款吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).catch((err) => err)
      if (confirmResult === 'confirm') {
        var that = this
        // refundOrder examinBatch
        that.$http.post('/order/refundOrder', _data2).then(function (response) {
          if (response.data.code == 200) {
            that.$notify.success({
              title: '提示',
              message: '退款成功',
              showClose: true
            })
            that.showDialog = false
            that.search()
          } else {
            that.$notify.info({
              title: '提示',
              message: response.data.message,
              showClose: true
            })
          }
        })
      }
    },
    // 修改
    async edit (row, boolean) {
      const that = this
      that.SqueryInfo.condition = {
        'siteCode': row?.siteCode,
        'taskCode': row?.taskCode
      }
      this.searchS()
      this.showDialog = true
    },

    // 删除用户
    async handleDelte (id) {
      const confirmResult = await this.$confirm('确定删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).catch((err) => err)
      if (confirmResult === 'confirm') {
        var that = this
        that.$http.post('/taskTeam/delete', { 'id': id }).then(function (response) {
          if (response.data.code == 200) {
            that.$notify.success({
              title: '提示',
              message: '删除成功',
              showClose: true
            })
            that.search()
          } else {
            that.$notify.info({
              title: '提示',
              message: response.data.message,
              showClose: true
            })
          }
        })
      }
    },
    handleSelectionChange (selection) {
      this.selectedRows = selection
    },
    // 批量删除
    batchDelete () {
      const that = this
      if (this.selectedRows.length === 0) {
        this.$message.warning('请先选择要删除的路线')
        return
      }
      this.$confirm('确定要删除选中的路线吗?', '警告', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          const _ids = that.selectedRows.map(item => item.id)
          that.$http
            .post('/taskTeam/deleteBatch', _ids)
            .then(function (res) {
              if (res.data.code == 200) {
                that.$notify.success({
                  title: '提示',
                  message: '删除成功',
                  showClose: true
                })
                that.search()
              } else {
                that.$notify.info({
                  title: '提示',
                  message: res.data.message,
                  showClose: true
                })
              }
            })
        })
        .catch(() => {
          this.$message.info('已取消删除')
        })
    },
    // 导出
    async toExport () {
      const loading = this.$loading({
        lock: true,
        text: '正在导出中，请稍后...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      const that = this
      const _data = {
        ...that.queryInfo.condition
      }
      let arr = this.selectedRows.map(item => {
        return {
          taskTeamCode: item.taskTeamCode
        }
      })
      let url = '/exportExcel/exportLoadOrder'
      if (this.activeName === '1') {
        url = '/exportExcel/exportLoadOrder'
      } else if (this.activeName === '2') {
        url = 'exportExcel/exportDeliveryOrder'
      } else if (this.activeName === '3') {
        url = '/exportExcel/exportSignOrder'
      }
      const res = await this.$http.post(url, arr[0],
        { responseType: 'blob' })
      if (res.status == 200) {
        try {
          const fileUrl = window.URL.createObjectURL(new Blob([res.data]))
          const link = document.createElement('a')
          link.href = fileUrl
          link.target = '_blank'
          link.setAttribute('download', `数据表格.xls`) // 设置导出的文件名称
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
          loading.close()
          that.$message({ type: 'success', message: '导出成功' })
        } catch (error) {
          this.$message.error(error)
        }
      }
    },

    search () {
      this.queryInfo.currPage = 1
      this.getList()
    },
    reset () {
      this.queryInfo.condition = {
        refundReviewStatus: null,
        orderType: null,
        plant: 0,
        refundStatus: null,
        supplierCode: '00000000',
        saleAfterStatus: 1,
        orderTime: ''
      }
      this.valuechange = []
      this.search()
    },
    // 新增按钮
    newBtn () {
      this.labelType = 'add'
      this.searchS()
      this.showDialog = true
      this.form = {
        siteList: [],
        siteNameList: [],
        siteCodeList: [],
        remarkList: []
      }
    },

    // 修改页数大小
    handleSizeChange (val) {
      this.queryInfo.pageSize = val
      this.getList()
    },

    // 获取当前页面
    handleCurrentChange (val) {
      this.queryInfo.currPage = val
      this.getList()
    },
    getSList () {
      var that = this
      this.taskTeamData = {}
      this.StableData = []
      that.$http.post('/taskTeam/queryTaskTeamProductList', that.SqueryInfo.condition).then(response => {
        if (response.data.code == 200) {
          that.taskTeamData = response.data.data?.taskTeam
          that.StableData = response.data.data?.orderItem
        }
      }).catch(err => {
        this.$message.warning('未获取到详情！')
      })
    },
    searchS () {
      this.SqueryInfo.currPage = 1
      this.getSList()
    },

    // 修改页数大小
    handleSSizeChange (val) {
      this.SqueryInfo.pageSize = val
      this.getSList()
    },

    // 获取当前页面
    handleSCurrentChange (val) {
      this.SqueryInfo.currPage = val
      this.getSList()
    }
  }
}
</script>

<style lang="less" scoped>
.ctag_item {
  margin-right: 4px;
}

.tabon {
  /deep/ .el-input__inner {
    cursor: pointer;
  }
}

.tableimg {
  width: 50px;
  height: 50px;
}

.search_form {
  /deep/ .el-form-item__content {
    height: 32px;
  }
}

.table_btn {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>
